import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { useStore } from '../../store';

const { CONTROLLERS: { STATEMENTS: { VERSION, BASE } } } = USER;

const { setStatementsData } = useStore.getState();

export const useStatementsListQuery = ({ customerId }: { customerId: string }) => useQuery(
  'statements',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`));
    return data;
  },
  {
    onSuccess: (data) => {
      setStatementsData(data);
    },
  },
);
